import { useMutation, useQuery } from '@tanstack/react-query';

import { useEndFlowModal } from '@/contexts/endFlowModalContext';

import {
  getAddress,
  getCities,
  getMeUser,
  GetMeUserParams,
  getPlaces,
  linkMe,
  onBoardingUpdate,
  onBoardingUpdateChurch,
  onBoardingUpdateSecular
} from '../functions/me';
import { NonProfitOrgType } from '../models/nonProfitOrgModels';

export const useGetMe = (params: GetMeUserParams) =>
  useQuery({
    queryKey: ['get-me-user', params.firebaseId, params.onBoardingType],
    queryFn: () => getMeUser(params),
    enabled: !!params
  });

export const useGetMeMutation = () =>
  useMutation({
    mutationFn: getMeUser,
    mutationKey: ['get-me-mutation'],
    onError: (e: any) => {
      console.error('Error getting me', e);
    }
  });

export const useLinkMe = () =>
  useMutation({
    mutationFn: linkMe,
    mutationKey: ['link-me'],
    onError: (e: any) => {
      console.error('Error linking me', e);
    }
  });

export const useOnBoarding = () => {
  const { showError } = useEndFlowModal();
  return useMutation({
    mutationFn: onBoardingUpdate,
    mutationKey: ['onboarding-me'],
    onError: (e: any) => {
      showError({});
      console.error('Error updating onboarding me', e);
    }
  });
};

export const useNpoOnboarding = (type: NonProfitOrgType) => {
  if (type === 'CHARITIES') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useOnBoardingSecular();
  } else {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useOnBoardingChurch();
  }
};

export const useOnBoardingChurch = () => {
  const { showError } = useEndFlowModal();
  return useMutation({
    mutationFn: onBoardingUpdateChurch,
    mutationKey: ['onboarding-church'],
    onError: (e: any) => {
      showError({});
      console.error('Error updating onboarding church', e);
    }
  });
};

export const useOnBoardingSecular = () => {
  const { showError } = useEndFlowModal();
  return useMutation({
    mutationFn: onBoardingUpdateSecular,
    mutationKey: ['onboarding-secular'],
    onError: (e: any) => {
      showError({});
      console.error('Error updating onboarding secular', e);
    }
  });
};

export const useGetCities = () =>
  useMutation({
    mutationKey: ['get-cities'],
    mutationFn: getCities
  });

export const useGetAddress = () =>
  useMutation({
    mutationKey: ['get-address'],
    mutationFn: getAddress
  });

export const useGetPlaceById = () =>
  useMutation({
    mutationKey: ['get-place-by-id'],
    mutationFn: getPlaces
  });
